import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { modal } from "../../common/modal";
import { Link } from "../../lib/Link";
import { openContactSelector } from "../../common/callUtil"

export const sitemap = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜サイトマップ';
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "サイトマップ" }])}
      
      <div className="sitemap">
        <h2 id="contentsHead">サイトマップ</h2>
        <div id="sitemap">
          <ul id="sitemapContents">
            <li>
              <Link to="/">トップ</Link>
            </li>
            <li>
              <Link to="/about/">セルフストレージとは</Link>
            </li>
            <li>
              <Link to="/lineup/">商品ラインナップ</Link>
              <ul>
                <li>
                  <Link to="/lineup/contena/">屋外型トランクルーム</Link>
                </li>
                <li>
                  <Link to="/lineup/trunk/">屋内型トランクルーム</Link>
                </li>
                <li>
                  <Link to="/lineup/premium/">トランクハウス24シリーズ</Link>
                </li>
                <li className="smLast">
                  <Link to="/lineup/bike/">バイク専用トランクルーム</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/flow/">ご契約について</Link>
            </li>
            <li>
              <Link to="/voice2/">活用事例</Link>
            </li>
            <li>
              <Link to="/search_campaign/">キャンペーン</Link>
            </li>
            <li>
              <a href="http://www.fudousan-100.com/" target="_blank">
                オーナー様へ
              </a>
            </li>
            <li>
              <Link to="/privacy/">個人情報の取扱いについて</Link>
            </li>
            <li>
              <Link to="/asct/">特商法に基づく表記</Link>
            </li>
            <li>
              <Link to="/agreement/">規約</Link>
            </li>
            <li>
              <Link to="/policy/">このサイトについて</Link>
            </li>
            <li>
              <a
                href="http://www.arealink.co.jp/corporate/profile.html"
                target="_blank"
              >
                会社案内
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" onClick={() => { openContactSelector({ eventTrackingId: 'tel_action_sitemap' }) }}>
                お問合せ
              </a>
            </li>
          </ul>
          <ul id="sitemapAv">
            <li>
              <Link to="/list/">全国から探す</Link>
            </li>
            <li>
              <Link to="/hokkaido/">北海道エリアから探す</Link>
            </li>
            <li>
              <Link to="/aomori/">青森エリアから探す</Link>
            </li>
            <li>
              <Link to="/akita/">秋田エリアから探す</Link>
            </li>
            <li>
              <Link to="/iwate/">岩手エリアから探す</Link>
            </li>
            <li>
              <Link to="/miyagi/">宮城エリアから探す</Link>
            </li>
            <li>
              <Link to="/yamagata/">山形エリアから探す</Link>
            </li>
            <li>
              <Link to="/fukushima/">福島エリアから探す</Link>
            </li>
            <li>
              <Link to="/tokyo/">東京エリアから探す</Link>
            </li>
            <li>
              <Link to="/kanagawa/">神奈川エリアから探す</Link>
            </li>
            <li>
              <Link to="/saitama/">埼玉エリアから探す</Link>
            </li>
            <li>
              <Link to="/chiba/">千葉エリアから探す</Link>
            </li>
            <li>
              <Link to="/tochigi/">栃木エリアから探す</Link>
            </li>
            <li>
              <Link to="/gunma/">群馬エリアから探す</Link>
            </li>
            <li>
              <Link to="/ibaraki/">茨城エリアから探す</Link>
            </li>
            <li>
              <Link to="/aichi/">愛知エリアから探す</Link>
            </li>
            <li>
              <Link to="/gifu/">岐阜エリアから探す</Link>
            </li>
            <li>
              <Link to="/mie/">三重エリアから探す</Link>
            </li>
            <li>
              <Link to="/shizuoka/">静岡エリアから探す</Link>
            </li>
            <li>
              <Link to="/niigata/">新潟エリアから探す</Link>
            </li>
            <li>
              <Link to="/ishikawa/">石川エリアから探す</Link>
            </li>
            <li>
              <Link to="/nagano/">長野エリアから探す</Link>
            </li>
            <li>
              <Link to="/fukui/">福井エリアから探す</Link>
            </li>
            <li>
              <Link to="/toyama/">富山エリアから探す</Link>
            </li>
            <li>
              <Link to="/yamanashi/">山梨エリアから探す</Link>
            </li>
            <li>
              <Link to="/osaka/">大阪エリアから探す</Link>
            </li>
            <li>
              <Link to="/hyogo/">兵庫エリアから探す</Link>
            </li>
            <li>
              <Link to="/kyoto/">京都エリアから探す</Link>
            </li>
            <li>
              <Link to="/nara/">奈良エリアから探す</Link>
            </li>
            <li>
              <Link to="/wakayama/">和歌山エリアから探す</Link>
            </li>
            <li>
              <Link to="/shiga/">滋賀エリアから探す</Link>
            </li>
            <li>
              <Link to="/okayama/">岡山エリアから探す</Link>
            </li>
            <li>
              <Link to="/hiroshima/">広島エリアから探す</Link>
            </li>
            <li>
              <Link to="/tottori/">鳥取エリアから探す</Link>
            </li>
            <li>
              <Link to="/shimane/">島根エリアから探す</Link>
            </li>
            <li>
              <Link to="/yamaguchi/">山口エリアから探す</Link>
            </li>
            <li>
              <Link to="/tokushima/">徳島エリアから探す</Link>
            </li>
            <li>
              <Link to="/kagawa/">香川エリアから探す</Link>
            </li>
            <li>
              <Link to="/ehime/">愛媛エリアから探す</Link>
            </li>
            <li>
              <Link to="/kouchi/">高知エリアから探す</Link>
            </li>
            <li>
              <Link to="/fukuoka/">福岡エリアから探す</Link>
            </li>
            <li>
              <Link to="/saga/">佐賀エリアから探す</Link>
            </li>
            <li>
              <Link to="/nagasaki/">長崎エリアから探す</Link>
            </li>
            <li>
              <Link to="/kumamoto/">熊本エリアから探す</Link>
            </li>
            <li>
              <Link to="/oita/">大分エリアから探す</Link>
            </li>
            <li>
              <Link to="/miyazaki/">宮崎エリアから探す</Link>
            </li>
            <li>
              <Link to="/kagoshima/">鹿児島エリアから探す</Link>
            </li>
            <li>
              <Link to="/okinawa/">沖縄エリアから探す</Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/sitemap.jsx